export function pickAmount(obj, ...keys) {
  if (!obj || typeof obj !== 'object') return null
  for (const k of keys) {
    if (obj[k] === undefined || obj[k] === null || obj[k] === '') continue
    const n = Number(obj[k])
    if (Number.isFinite(n)) return n
  }
  return null
}

export function readWalletBalance(source) {
  return pickAmount(source, 'walletBalance', 'WalletBalance', 'wallet_balance')
}

export function readCommissionPercent(source) {
  const n = pickAmount(source, 'comission', 'Comission', 'commission', 'Commission')
  if (n == null) return 0
  return Math.min(100, Math.max(0, n))
}

export function detectIframe() {
  try {
    return window.self !== window.top
  } catch {
    return true
  }
}

export function reloadClientFromStorage(clientStore) {
  try {
    const stored = localStorage.getItem('client')
    if (!stored || !clientStore) return
    const parsed = JSON.parse(stored)
    if (parsed && typeof parsed === 'object') {
      clientStore.client = parsed
    }
  } catch {
    // ignore
  }
}

/** No iframe o jogador paga o valor cheio; fora, desconta a comissão do vendedor. */
export function requiredWalletAmount(totalBetValue, commissionPercent = 0, iframe = false) {
  const total = Number(totalBetValue) || 0
  if (iframe) return total
  const rate = Math.min(100, Math.max(0, Number(commissionPercent) || 0)) / 100
  return Math.round(total * (1 - rate) * 100) / 100
}

export function hasEnoughWallet(balance, required) {
  const b = Number(balance)
  const r = Number(required)
  if (!Number.isFinite(b) || !Number.isFinite(r)) return false
  return b + 0.009 >= r
}

export function isSeamlessMode() {
  try {
    return localStorage.getItem('seamlessWallet') === '1'
  } catch {
    return false
  }
}

export function getIframeSessionParams() {
  let session = ''
  let client = ''
  try {
    const params = new URLSearchParams(window.location.search)
    session = params.get('session') || params.get('Session') || ''
    client = params.get('client') || params.get('t') || params.get('apiKey') || ''
  } catch {
    // ignore
  }
  try {
    if (!session) session = localStorage.getItem('iframeSession') || ''
    if (!client) client = localStorage.getItem('iframeClient') || ''
  } catch {
    // ignore
  }
  return { session: String(session || '').trim(), client: String(client || '').trim() }
}

export function persistIframeSession(session, client, seamless) {
  try {
    if (session) localStorage.setItem('iframeSession', session)
    if (client) localStorage.setItem('iframeClient', client)
    if (seamless) localStorage.setItem('seamlessWallet', '1')
  } catch {
    // ignore
  }
}

export function clearIframeSession() {
  try {
    localStorage.removeItem('iframeSession')
    localStorage.removeItem('iframeClient')
    localStorage.removeItem('seamlessWallet')
  } catch {
    // ignore
  }
}

export function applyWalletToClient(clientStore, balance, limit) {
  if (!clientStore?.client) return
  if (Number.isFinite(Number(balance))) {
    clientStore.client.walletBalance = Number(balance)
  }
  if (limit != null && Number.isFinite(Number(limit))) {
    clientStore.client.walletLimit = Number(limit)
  }
  try {
    localStorage.setItem('client', JSON.stringify(clientStore.client))
  } catch {
    // ignore
  }
  window.dispatchEvent(new CustomEvent('wallet-updated'))
}

/**
 * Saldo vivo no cassino via SessionWebhook (HTTP).
 * Não depende de postMessage no site pai.
 */
export async function syncWalletFromSession(clientStore) {
  const { session, client } = getIframeSessionParams()
  if (!session) return { ok: false, reason: 'no-session' }
  try {
    const { default: apiService } = await import('../services/apiService')
    const data = await apiService.refreshIframeWallet(session, client)
    const balance = readWalletBalance(data)
    const limit = pickAmount(data, 'walletLimit', 'WalletLimit')
    if (balance == null) return { ok: false, reason: 'no-balance' }
    applyWalletToClient(clientStore, balance, limit)
    const seamless = !!(data?.seamlessWallet ?? data?.SeamlessWallet)
    if (seamless) {
      try { localStorage.setItem('seamlessWallet', '1') } catch { /* ignore */ }
    }
    return { ok: true, balance, limit }
  } catch (e) {
    return { ok: false, reason: e?.message || 'session-failed' }
  }
}

export function friendlyBetError(raw) {
  const message = String(raw || '').trim()
  const text = message.toLowerCase()
  if (!text) return 'Não foi possível enviar a aposta. Tente novamente.'
  if (
    text.includes('partner balance callback') ||
    text.includes('callback unavailable') ||
    text.includes('webhook_error') ||
    text.includes('não foi possível debitar') ||
    text.includes('session-failed') ||
    text.includes('no-session')
  ) {
    return 'Não foi possível confirmar seu saldo no cassino. Tente novamente.'
  }
  if (text.includes('saldo insuficiente') || text.includes('insufficient')) {
    return 'Saldo insuficiente para esta aposta.'
  }
  if (text.includes('cooldown') || text.includes('aguarde')) {
    return message
  }
  if (
    text.includes('is not a function') ||
    text.includes('callback') ||
    text.includes('unavailable') ||
    text.includes('exception') ||
    text.includes('undefined')
  ) {
    return 'Não foi possível enviar a aposta. Atualize a página e tente de novo.'
  }
  return message
}
